// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 创建波段交易回测 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 POST /qt-adviser/swing-trade/backtest/create */
export async function qtAdviserSwingTradeBacktestCreateUsingPOST(
  body: API.SwingTradeBacktestCreateReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultlong>('/qt-adviser/swing-trade/backtest/create', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 删除波段交易回测 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 POST /qt-adviser/swing-trade/backtest/delete */
export async function qtAdviserSwingTradeBacktestDeleteUsingPOST(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.qtAdviserSwingTradeBacktestDeleteUsingPOSTParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/qt-adviser/swing-trade/backtest/delete', {
    method: 'POST',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取波段交易回测详情 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /qt-adviser/swing-trade/backtest/info */
export async function qtAdviserSwingTradeBacktestInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.qtAdviserSwingTradeBacktestInfoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultSwingTradeBacktestInfoResp>(
    '/qt-adviser/swing-trade/backtest/info',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 获取用户波段交易回测列表 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /qt-adviser/swing-trade/backtest/list */
export async function qtAdviserSwingTradeBacktestListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.qtAdviserSwingTradeBacktestListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListSwingTradeBacktestResp>(
    '/qt-adviser/swing-trade/backtest/list',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 获取波段交易回测持仓列表 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /qt-adviser/swing-trade/backtest/position-list */
export async function qtAdviserSwingTradeBacktestPositionListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.qtAdviserSwingTradeBacktestPositionListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListSwingTradeBacktestPositionResp>(
    '/qt-adviser/swing-trade/backtest/position-list',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 获取波段交易回测收益列表 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /qt-adviser/swing-trade/backtest/profit-list */
export async function qtAdviserSwingTradeBacktestProfitListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.qtAdviserSwingTradeBacktestProfitListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListSwingTradeBacktestProfitResp>(
    '/qt-adviser/swing-trade/backtest/profit-list',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 获取波段交易回测收益统计 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /qt-adviser/swing-trade/backtest/profit-statistics */
export async function qtAdviserSwingTradeBacktestProfitStatisticsUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.qtAdviserSwingTradeBacktestProfitStatisticsUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultSwingTradeBacktestProfitStatisticsResp>(
    '/qt-adviser/swing-trade/backtest/profit-statistics',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}
